import { useNavigate } from "react-router";
import { BusinessSettings } from "@/design/BusinessSettings";
import { MEMBER_DELETION } from "@/design/deletionCopy";
import { DeleteAccountForm } from "@/design/ProfileForms";
import { memberDeletionStateFor } from "@/modules/identity/commands/profileCopy";
import { useMe } from "~/auth/MeProvider";
import { forgetSession } from "~/auth/supabase";
import { AppLink } from "~/components/AppLink";
import { BusinessPage } from "~/components/BusinessChrome";
import { post } from "~/lib/api";

/**
 * BusinessSettingsScreen (docs/ux/screens/BusinessSettingsScreen.md).
 *
 * **The one business screen with no read at all**, which is why it has no
 * pending state and no failure state: it is a hub of links, and it renders
 * whether or not anything else is reachable. That is deliberate rather than
 * incidental, because this is where somebody goes when they are trying to fix
 * something, and a settings page that fails with the database is unhelpful at
 * exactly the wrong moment.
 */
export function BusinessSettingsScreen() {
  const { signOut } = useMe();
  const navigate = useNavigate();

  return (
    <BusinessPage>
      <BusinessSettings
        Link={AppLink}
        logout={
          <button
            type="button"
            className="text-sm font-medium text-muted hover:text-ink"
            onClick={() => {
              void signOut().then(() => navigate("/", { replace: true }));
            }}
          >
            Log out
          </button>
        }
        deleteAccount={
          <DeleteAccountForm
            copy={MEMBER_DELETION}
            destroy={async (currentPassword) => {
              const result = await post("/auth/staff/delete", { currentPassword });
              if (!result.ok) return memberDeletionStateFor(result.failure);
              // The account is gone, so the session goes with it, and the
              // person lands where a signed-out visitor does (H58).
              await forgetSession();
              void navigate("/", { replace: true });
              return {};
            }}
          />
        }
      />
    </BusinessPage>
  );
}
